import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'
import styled from '@emotion/styled'

export const Wrapper = styled(Box)`
  ${({ theme, $autoHeight }) => `
    background-color: ${theme.palette.background.gray};
    width: 100%;
    height: 100%;
    padding: 16px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    ${theme.breakpoints.up('md')} {
      padding: 20px;
    }

    ${theme.breakpoints.up('lg')} {
      width: 724px;
      height: ${$autoHeight ? 'auto' : '620px'};
      border-radius: 10px;
    }
  `}
`

export const ScrollableWrapper = styled(Box)`
  height: calc(100% - 100px);
  max-height: calc(100% - 100px);
  overflow-y: auto;
  overflow-x: hidden;
  scroll-behavior: smooth;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
`

export const StickyWrapper = styled(Box)`
  position: sticky;
  top: 0;
  z-index: 8;
`

export const ServiceClassificationWrapper = styled(Box)`
  ${({ theme, $isFirst }) => `
    background-color: ${theme.palette.background.default};;
    border-radius: 12px;
    height: auto;
    width: 100%;
    padding: 16px;
    margin-top: ${$isFirst ? '0px' : '16px'};

    ${theme.breakpoints.up('lg')} {
      padding: 20px;
    }
  `}
`

export const ServiceIconWrapper = styled(Box)`
  width: 100%;
  display: inline-block;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const LogoImageWrapper = styled(Box)`
  ${({ $hovered }) => `
    position: relative;
    margin-bottom: 8px;

    transform: ${$hovered ? 'translate(0, -8px)' : 'translate(0, 0)'};
    transition: all 0.2s ease-in-out;
  `}
`

export const HoverCardPoint = styled(Box)`
  ${({ theme, $hovered }) => `
    height: 4px;
    width: 4px;
    border-radius: 50%;
    background-color: ${$hovered ? theme.palette.primary.main : 'transparent'};
    position: absolute;
    left: 50%;
    bottom: -8px;
    transform: translate(-50%, 0);
  `}
`

export const IconButtonWrapper = styled(IconButton)`
  ${({ theme }) => `
  > .MuiSvgIcon-root {
    fill: ${theme.palette.text.minus2};
    font-size: 24px;
  }
`}
`

export const ButtonWrapper = styled(Box)`
  position: absolute;
  bottom: 0;
  right: 0;
  padding: 20px;
  width: 100%;
  background-color: white;
  display: flex;
  justify-content: end;
  border-radius: 10px;
`

export const BookingServiceModalWrapper = styled(Wrapper)`
  ${({ theme }) => `
    background-color: ${theme.palette.background.default};
  `}
`

export const BookingServiceClassificationWrapper = styled(
  ServiceClassificationWrapper
)`
  ${({ theme }) => `
    background-color:  ${theme.palette.background.gray};;
  `}
`
